// @flow
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';

// import { initMap } from '../../maps';
import type { Address } from '../../actions/types';

const InputTextField = withStyles({
	root: {
		'& .MuiInput-underline, & .MuiTypography-root': {
			'&:after': {
				borderBottom: '2px solid #bfd730',
			},
		},
		'& label': {
			fontSize: 13,
			transform: 'translate(0, 17px) scale(1)',
			'&.Mui-focused': {
				color: 'black',
			},
			'&.MuiInputLabel-shrink': {
				transform: 'translate(0, -0.5px) scale(0.75)',
			},
		},
		'& label + .MuiInput-formControl': {
			margin: '6px 0',
			fontSize: 14,
		},
	},
})(TextField);

const useStyles = makeStyles((theme) => ({
	container: {
		// padding: 10,
		color: 'black',
		fontSize: 14,
	},
	mainContainer: {
		color: '#6b6b6b',
	},
	editAddresBtn: {
		color: '#869a12',
		fontWeight: 'bold',
		fontSize: 14,
		padding: '0 10px',
		textTransform: 'capitalize',
		lineHeight: '14px',
	},
	buttonProgress: {
		color: '#bedc13',
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12,
	},
	saveBtn: {
		borderRadius: '4px',
		backgroundColor: '#869a12',
		width: '50px',
		flex: 'auto',
		height: 32,
		'&:hover': {
			backgroundColor: '#869a12',
		},
	},
	locationIcon: {
		fontSize: '14px !important',
		verticalAlign: 'bottom',
		width: 17,
		height: 17,
		position: 'relative',
		left: -2,
	},
	address: {
		display: 'flex',
		'& .MuiButton-root:not(:last-child)' : {
			paddingRight: 0,
		}
	},
}));

type Props = {|
	showMap?: boolean,
	location?: Address,
	savingAddress: boolean,
	showEditBtn: boolean,
	showAddBtn:boolean,
	editAddressMode: boolean,
	showError: boolean,
	editFlatNo?: (string) => void,
	editNickName?: (string) => void,
	editAddress?: () => void,
	addAddress?: () => void,
|};

function ViewAddress({
	showMap = false,
	location = {},
	editAddressMode = false,
	savingAddress = false,
	showEditBtn = false,
	showAddBtn=false,
	showError = false,
	editFlatNo = () => {},
	editNickName = () => {},
	editAddress = () => {},
	addAddress = () => {},
}: Props) {
	const { flat_building = '', label = '', address = '', area_name = '' } = location || {};
	const classes = useStyles();

	return (
		<section className={classes.container}>
			<section>
				<header style={{ marginBottom: 6 }}>Delivery Address{label && <span>{`: ${label}`}</span>}</header>
				<main className={classes.mainContainer}>
					<section style={{ marginBottom: 6 }}>
						<LocationOnOutlinedIcon className={classes.locationIcon} />
						{area_name && `${area_name}, `}{address}
					</section>
					{flat_building && !editAddressMode ? (
						<section className={classes.address}>
							<div>{flat_building}</div>
							{showEditBtn && !savingAddress && (
								<Button
									aria-label='add-edit-address'
									classes={{ root: classes.editAddresBtn }}
									onClick={editAddress}
								>
									Edit Address
								</Button>
							)}
							{showAddBtn && !savingAddress && (
								<Button
									aria-label='add-edit-address'
									classes={{ root: classes.editAddresBtn }}
									onClick={addAddress}
								>
									Add Address
								</Button>
							)}
						</section>
					) : (
						editAddressMode && (
							<section>
								<InputTextField
									id='flat-apt-building'
									label='Flat/Apt Building'
									style={{ width: '100%' }}
									value={flat_building}
									inputProps={{autoComplete: 'off'}}
									onChange={(event) => editFlatNo(event.target.value)}
									required
								/>
								<div style={{ display: 'flex', alignItems: 'baseline' }}>
									<InputTextField
										id='label'
										label='Nick name'
										value={label}
										style={{ width: '100%' }}
										inputProps={{autoComplete: 'off'}}
										className={classes.nickNameText}
										onChange={(event) => editNickName(event.target.value)}
										required
									/>
								</div>
								{showError && <div style={{ color: '#cc2525' }}>All Fields are reuqired</div>}
							</section>
						)
					)}
				</main>
			</section>
		</section>
	);
}

ViewAddress.propTypes = {
	showMap: PropTypes.bool,
	location: PropTypes.object,
	savingAddress: PropTypes.bool.isRequired,
	editAddressMode: PropTypes.bool.isRequired,
	showEditBtn: PropTypes.bool.isRequired,
	showError: PropTypes.bool.isRequired,
	editFlatNo: PropTypes.func,
	editNickName: PropTypes.func,
	editAddress: PropTypes.func,
};

export default ViewAddress;
